// Generated by purs version 0.15.0
import * as Data_Array from "../Data.Array/index.js";
import * as Data_Eq from "../Data.Eq/index.js";
import * as Data_Eq_Generic from "../Data.Eq.Generic/index.js";
import * as Data_Foldable from "../Data.Foldable/index.js";
import * as Data_Functor from "../Data.Functor/index.js";
import * as Data_Generic_Rep from "../Data.Generic.Rep/index.js";
import * as Data_Maybe from "../Data.Maybe/index.js";
import * as Data_Money_Rounded from "../Data.Money.Rounded/index.js";
import * as Data_Monoid from "../Data.Monoid/index.js";
import * as Data_Newtype from "../Data.Newtype/index.js";
import * as Data_Numeric from "../Data.Numeric/index.js";
import * as Data_Ord from "../Data.Ord/index.js";
import * as Data_Semigroup from "../Data.Semigroup/index.js";
import * as Data_Set from "../Data.Set/index.js";
import * as Data_Show from "../Data.Show/index.js";
import * as Data_Show_Generic from "../Data.Show.Generic/index.js";
import * as Data_Tuple from "../Data.Tuple/index.js";
import * as Foreign_Encoding from "../Foreign.Encoding/index.js";
import * as Foreign_Generic_Class from "../Foreign.Generic.Class/index.js";
import * as Restaumatic_Promotions_Types_PromotionalItem from "../Restaumatic.Promotions.Types.PromotionalItem/index.js";
import * as Restaumatic_PromotionsEngine_Cart_CartParams from "../Restaumatic.PromotionsEngine.Cart.CartParams/index.js";
import * as Restaumatic_PromotionsEngine_Cart_ProductItem from "../Restaumatic.PromotionsEngine.Cart.ProductItem/index.js";
import * as Restaumatic_PromotionsEngine_Common from "../Restaumatic.PromotionsEngine.Common/index.js";
import * as Restaumatic_PromotionsEngine_Promotions_Promotion from "../Restaumatic.PromotionsEngine.Promotions.Promotion/index.js";
import * as Restaumatic_PromotionsEngine_Promotions_Types_Promotion from "../Restaumatic.PromotionsEngine.Promotions.Types.Promotion/index.js";
var TargetCart = /* #__PURE__ */ (function () {
    function TargetCart() {

    };
    TargetCart.value = new TargetCart();
    return TargetCart;
})();
var TargetProductItems = /* #__PURE__ */ (function () {
    function TargetProductItems(value0) {
        this.value0 = value0;
    };
    TargetProductItems.create = function (value0) {
        return new TargetProductItems(value0);
    };
    return TargetProductItems;
})();
var NoSource = /* #__PURE__ */ (function () {
    function NoSource() {

    };
    NoSource.value = new NoSource();
    return NoSource;
})();
var SourceProductItems = /* #__PURE__ */ (function () {
    function SourceProductItems(value0) {
        this.value0 = value0;
    };
    SourceProductItems.create = function (value0) {
        return new SourceProductItems(value0);
    };
    return SourceProductItems;
})();
var AssignmentToCart = /* #__PURE__ */ (function () {
    function AssignmentToCart() {

    };
    AssignmentToCart.value = new AssignmentToCart();
    return AssignmentToCart;
})();
var UnassignmentToCart = /* #__PURE__ */ (function () {
    function UnassignmentToCart() {

    };
    UnassignmentToCart.value = new UnassignmentToCart();
    return UnassignmentToCart;
})();
var AssignmentToProduct = /* #__PURE__ */ (function () {
    function AssignmentToProduct(value0) {
        this.value0 = value0;
    };
    AssignmentToProduct.create = function (value0) {
        return new AssignmentToProduct(value0);
    };
    return AssignmentToProduct;
})();
var UnassignmentToProduct = /* #__PURE__ */ (function () {
    function UnassignmentToProduct() {

    };
    UnassignmentToProduct.value = new UnassignmentToProduct();
    return UnassignmentToProduct;
})();
var AutoEnabled = /* #__PURE__ */ (function () {
    function AutoEnabled() {

    };
    AutoEnabled.value = new AutoEnabled();
    return AutoEnabled;
})();
var AutoDisabled = /* #__PURE__ */ (function () {
    function AutoDisabled() {

    };
    AutoDisabled.value = new AutoDisabled();
    return AutoDisabled;
})();
var UserEnabled = /* #__PURE__ */ (function () {
    function UserEnabled(value0) {
        this.value0 = value0;
    };
    UserEnabled.create = function (value0) {
        return new UserEnabled(value0);
    };
    return UserEnabled;
})();
var UserDisabled = /* #__PURE__ */ (function () {
    function UserDisabled() {

    };
    UserDisabled.value = new UserDisabled();
    return UserDisabled;
})();
var PromotionalItem = function (x) {
    return x;
};
var selectionStatusAge = function (v) {
    if (v instanceof UserEnabled) {
        return new Data_Maybe.Just(v.value0);
    };
    return Data_Maybe.Nothing.value;
};
var productItemKeysInTarget = function (v) {
    if (v instanceof TargetCart) {
        return Data_Set.empty;
    };
    if (v instanceof TargetProductItems) {
        return v.value0;
    };
    throw new Error("Failed pattern match at Restaumatic.PromotionsEngine.Cart.PromotionalItem (line 147, column 1 - line 147, column 84): " + [ v.constructor.name ]);
};
var oldenUserEnabledSelectionStatus = function (v) {
    if (v instanceof UserEnabled) {
        return new UserEnabled(Data_Numeric.add(Data_Numeric.additiveInt)(v.value0)(1));
    };
    return v;
};
var newtypePromotionalItem = {
    Coercible0: function () {
        return undefined;
    }
};
var promotion = /* #__PURE__ */ (function () {
    var $182 = Data_Newtype.unwrap();
    return function ($183) {
        return (function (v) {
            return v.promotion;
        })($182($183));
    };
})();
var promotionId = function ($184) {
    return Restaumatic_PromotionsEngine_Promotions_Promotion.promotionId(promotion($184));
};
var promotions = /* #__PURE__ */ Data_Functor.map(Data_Functor.functorArray)(promotion);
var promotionalItemId = /* #__PURE__ */ (function () {
    var $185 = Data_Newtype.unwrap();
    return function ($186) {
        return (function (v) {
            return v.promotionalItemId;
        })($185($186));
    };
})();
var promotionalItemInput = /* #__PURE__ */ (function () {
    var $187 = Data_Newtype.unwrap();
    return function ($188) {
        return (function (v) {
            return v.input;
        })($187($188));
    };
})();
var selectedFreeby = function (promoItem) {
    var v = promotionalItemInput(promoItem);
    if (v instanceof Restaumatic_Promotions_Types_PromotionalItem.FreeProductInput) {
        return Restaumatic_PromotionsEngine_Promotions_Promotion.findPromotionFreeby(v.value0.selection)(promotion(promoItem));
    };
    return Data_Maybe.Nothing.value;
};
var promotionalItemValue = /* #__PURE__ */ (function () {
    var $189 = Data_Newtype.unwrap();
    return function ($190) {
        return (function (v) {
            return v.value;
        })($189($190));
    };
})();
var selection = /* #__PURE__ */ (function () {
    var $191 = Data_Newtype.unwrap();
    return function ($192) {
        return (function (v) {
            return v.selection;
        })($191($192));
    };
})();
var oldenUserSelection = function (promoItem) {
    return Data_Newtype.wrap()((function () {
        var v = Data_Newtype.unwrap()(promoItem);
        var $86 = {};
        for (var $87 in v) {
            if ({}.hasOwnProperty.call(v, $87)) {
                $86[$87] = v[$87];
            };
        };
        $86.selection = oldenUserEnabledSelectionStatus(selection(promoItem));
        return $86;
    })());
};
var selectionAge = function ($193) {
    return selectionStatusAge(selection($193));
};
var setActive = function (active) {
    return function (promoItem) {
        return Data_Newtype.wrap()((function () {
            var v = Data_Newtype.unwrap()(promoItem);
            var $89 = {};
            for (var $90 in v) {
                if ({}.hasOwnProperty.call(v, $90)) {
                    $89[$90] = v[$90];
                };
            };
            $89.active = active;
            return $89;
        })());
    };
};
var setInputFreeby = function (freeby) {
    return function (promoItem) {
        return Data_Newtype.wrap()((function () {
            var v = Data_Newtype.unwrap()(promoItem);
            var $92 = {};
            for (var $93 in v) {
                if ({}.hasOwnProperty.call(v, $93)) {
                    $92[$93] = v[$93];
                };
            };
            $92.input = new Restaumatic_Promotions_Types_PromotionalItem.FreeProductInput({
                selection: freeby
            });
            return $92;
        })());
    };
};
var selectFreeby = function (freeby) {
    return function (promoItem) {
        var $95 = Restaumatic_PromotionsEngine_Promotions_Promotion.isInPromotionFreebies(freeby)(promotion(promoItem));
        if ($95) {
            return setInputFreeby(freeby)(promoItem);
        };
        return promoItem;
    };
};
var setNoInput = function (promoItem) {
    return Data_Newtype.wrap()((function () {
        var v = Data_Newtype.unwrap()(promoItem);
        var $96 = {};
        for (var $97 in v) {
            if ({}.hasOwnProperty.call(v, $97)) {
                $96[$97] = v[$97];
            };
        };
        $96.input = Restaumatic_Promotions_Types_PromotionalItem.NoInput.value;
        return $96;
    })());
};
var setSelection = function (selectionStatus) {
    return function (promoItem) {
        return Data_Newtype.wrap()((function () {
            var v = Data_Newtype.unwrap()(promoItem);
            var $99 = {};
            for (var $100 in v) {
                if ({}.hasOwnProperty.call(v, $100)) {
                    $99[$100] = v[$100];
                };
            };
            $99.selection = selectionStatus;
            return $99;
        })());
    };
};
var setValue = function (newValue) {
    return function (promoItem) {
        return Data_Newtype.wrap()((function () {
            var v = Data_Newtype.unwrap()(promoItem);
            var $102 = {};
            for (var $103 in v) {
                if ({}.hasOwnProperty.call(v, $103)) {
                    $102[$103] = v[$103];
                };
            };
            $102.value = newValue;
            return $102;
        })());
    };
};
var source = /* #__PURE__ */ (function () {
    var $194 = Data_Newtype.unwrap();
    return function ($195) {
        return (function (v) {
            return v.source;
        })($194($195));
    };
})();
var sourceProductItems = function (item) {
    var v = source(item);
    if (v instanceof NoSource) {
        return [  ];
    };
    if (v instanceof SourceProductItems) {
        return v.value0;
    };
    throw new Error("Failed pattern match at Restaumatic.PromotionsEngine.Cart.PromotionalItem (line 313, column 3 - line 315, column 58): " + [ v.constructor.name ]);
};
var target = /* #__PURE__ */ (function () {
    var $196 = Data_Newtype.unwrap();
    return function ($197) {
        return (function (v) {
            return v.target;
        })($196($197));
    };
})();
var targetProductItemKeys = function ($198) {
    return productItemKeysInTarget(target($198));
};
var targetContains = function (dictOrd) {
    return function (promoItem) {
        return function (prodKey) {
            return Data_Set.member(Restaumatic_PromotionsEngine_Cart_ProductItem.ordProductItemKey(dictOrd))(prodKey)(targetProductItemKeys(promoItem));
        };
    };
};
var value = /* #__PURE__ */ (function () {
    var $199 = Data_Newtype.unwrap();
    return function ($200) {
        return (function (v) {
            return v.value;
        })($199($200));
    };
})();
var mkUserEnabled = /* #__PURE__ */ (function () {
    return UserEnabled.create;
})();
var mkUserEnabledDefault = /* #__PURE__ */ mkUserEnabled(0);
var mkUserDisabled = /* #__PURE__ */ (function () {
    return UserDisabled.value;
})();
var mkUnassignmentToProduct = /* #__PURE__ */ (function () {
    return UnassignmentToProduct.value;
})();
var mkUnassignmentToCart = /* #__PURE__ */ (function () {
    return UnassignmentToCart.value;
})();
var mkTargetItems = function (dictFoldable) {
    return function (dictOrd) {
        var $201 = Data_Set.fromFoldable(dictFoldable)(Restaumatic_PromotionsEngine_Cart_ProductItem.ordProductItemKey(dictOrd));
        return function ($202) {
            return TargetProductItems.create($201($202));
        };
    };
};
var mkTargetCart = /* #__PURE__ */ (function () {
    return TargetCart.value;
})();
var mkSourceItems = /* #__PURE__ */ (function () {
    return SourceProductItems.create;
})();
var mkPromotionalItem = function (promoItemId) {
    return function (promo) {
        return function (initSelection) {
            return function (initInput) {
                return function (initVal) {
                    return function (initAssignement) {
                        return function (initTarget) {
                            return function (initSource) {
                                return {
                                    promotionalItemId: promoItemId,
                                    promotion: promo,
                                    target: initTarget,
                                    source: initSource,
                                    assignment: initAssignement,
                                    selection: initSelection,
                                    input: initInput,
                                    value: initVal,
                                    active: true
                                };
                            };
                        };
                    };
                };
            };
        };
    };
};
var mkNoSource = /* #__PURE__ */ (function () {
    return NoSource.value;
})();
var mkNoInput = /* #__PURE__ */ (function () {
    return Restaumatic_Promotions_Types_PromotionalItem.NoInput.value;
})();
var mkFreeProductInput = function (freeProductChoice) {
    return new Restaumatic_Promotions_Types_PromotionalItem.FreeProductInput({
        selection: freeProductChoice
    });
};
var mkDefaultAssignment = function (promo) {
    var v = Restaumatic_PromotionsEngine_Promotions_Promotion.promotionTarget(promo);
    if (v instanceof Restaumatic_PromotionsEngine_Promotions_Types_Promotion.CartTarget) {
        return UnassignmentToCart.value;
    };
    if (v instanceof Restaumatic_PromotionsEngine_Promotions_Types_Promotion.ProductTarget) {
        return UnassignmentToProduct.value;
    };
    throw new Error("Failed pattern match at Restaumatic.PromotionsEngine.Cart.PromotionalItem (line 143, column 3 - line 145, column 43): " + [ v.constructor.name ]);
};
var mkAutoEnabled = /* #__PURE__ */ (function () {
    return AutoEnabled.value;
})();
var mkAutoDisabled = /* #__PURE__ */ (function () {
    return AutoDisabled.value;
})();
var mkAssignmentToProduct = /* #__PURE__ */ (function () {
    return AssignmentToProduct.create;
})();
var mkAssignmentToCart = /* #__PURE__ */ (function () {
    return AssignmentToCart.value;
})();
var isUserSelection = function (v) {
    if (v instanceof UserEnabled) {
        return true;
    };
    if (v instanceof UserDisabled) {
        return true;
    };
    return false;
};
var isUserEnabledSelection = function (v) {
    if (v instanceof UserEnabled) {
        return true;
    };
    return false;
};
var isUserDisabledSelection = function (v) {
    if (v instanceof UserDisabled) {
        return true;
    };
    return false;
};
var isTouchedByUser = /* #__PURE__ */ (function () {
    var $203 = Data_Newtype.unwrap();
    return function ($204) {
        return isUserSelection((function (v) {
            return v.selection;
        })($203($204)));
    };
})();
var isProductPromotionalItem = function ($205) {
    return Restaumatic_PromotionsEngine_Promotions_Promotion.isProductPromotion(promotion($205));
};
var isEnabledSelection = function (v) {
    if (v instanceof UserEnabled) {
        return true;
    };
    if (v instanceof AutoEnabled) {
        return true;
    };
    return false;
};
var isEnabledByUser = /* #__PURE__ */ (function () {
    var $206 = Data_Newtype.unwrap();
    return function ($207) {
        return isUserEnabledSelection((function (v) {
            return v.selection;
        })($206($207)));
    };
})();
var isEnabled = /* #__PURE__ */ (function () {
    var $208 = Data_Newtype.unwrap();
    return function ($209) {
        return isEnabledSelection((function (v) {
            return v.selection;
        })($208($209)));
    };
})();
var isCartPromotionalItem = function ($210) {
    return Restaumatic_PromotionsEngine_Promotions_Promotion.isCartPromotion(promotion($210));
};
var isAutoAssignablePromotionalItem = function ($211) {
    return Restaumatic_PromotionsEngine_Promotions_Promotion.isAutoAssignablePromotion(promotion($211));
};
var isActive = /* #__PURE__ */ (function () {
    var $212 = Data_Newtype.unwrap();
    return function ($213) {
        return (function (v) {
            return v.active;
        })($212($213));
    };
})();
var input = /* #__PURE__ */ (function () {
    var $214 = Data_Newtype.unwrap();
    return function ($215) {
        return (function (v) {
            return v.input;
        })($214($215));
    };
})();
var hasRequiredInput = function (item) {
    var v = input(item);
    var v1 = Restaumatic_PromotionsEngine_Promotions_Promotion.promotionPrize(promotion(item));
    return true;
};
var isItemAutoAssigneable = function (item) {
    return isAutoAssignablePromotionalItem(item) && hasRequiredInput(item);
};
var genericSelectionStatus = {
    to: function (x) {
        if (x instanceof Data_Generic_Rep.Inl) {
            return AutoEnabled.value;
        };
        if (x instanceof Data_Generic_Rep.Inr && x.value0 instanceof Data_Generic_Rep.Inl) {
            return AutoDisabled.value;
        };
        if (x instanceof Data_Generic_Rep.Inr && (x.value0 instanceof Data_Generic_Rep.Inr && x.value0.value0 instanceof Data_Generic_Rep.Inl)) {
            return new UserEnabled(x.value0.value0.value0);
        };
        if (x instanceof Data_Generic_Rep.Inr && (x.value0 instanceof Data_Generic_Rep.Inr && x.value0.value0 instanceof Data_Generic_Rep.Inr)) {
            return UserDisabled.value;
        };
        throw new Error("Failed pattern match at Restaumatic.PromotionsEngine.Cart.PromotionalItem (line 89, column 1 - line 89, column 68): " + [ x.constructor.name ]);
    },
    from: function (x) {
        if (x instanceof AutoEnabled) {
            return new Data_Generic_Rep.Inl(Data_Generic_Rep.NoArguments.value);
        };
        if (x instanceof AutoDisabled) {
            return new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inl(Data_Generic_Rep.NoArguments.value));
        };
        if (x instanceof UserEnabled) {
            return new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inl(x.value0)));
        };
        if (x instanceof UserDisabled) {
            return new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(Data_Generic_Rep.NoArguments.value)));
        };
        throw new Error("Failed pattern match at Restaumatic.PromotionsEngine.Cart.PromotionalItem (line 89, column 1 - line 89, column 68): " + [ x.constructor.name ]);
    }
};
var showSelectionStatus = {
    show: /* #__PURE__ */ Data_Show_Generic.genericShow(genericSelectionStatus)(/* #__PURE__ */ Data_Show_Generic.genericShowSum(/* #__PURE__ */ Data_Show_Generic.genericShowConstructor(Data_Show_Generic.genericShowArgsNoArguments)({
        reflectSymbol: function () {
            return "AutoEnabled";
        }
    }))(/* #__PURE__ */ Data_Show_Generic.genericShowSum(/* #__PURE__ */ Data_Show_Generic.genericShowConstructor(Data_Show_Generic.genericShowArgsNoArguments)({
        reflectSymbol: function () {
            return "AutoDisabled";
        }
    }))(/* #__PURE__ */ Data_Show_Generic.genericShowSum(/* #__PURE__ */ Data_Show_Generic.genericShowConstructor(/* #__PURE__ */ Data_Show_Generic.genericShowArgsArgument(Data_Show.showInt))({
        reflectSymbol: function () {
            return "UserEnabled";
        }
    }))(/* #__PURE__ */ Data_Show_Generic.genericShowConstructor(Data_Show_Generic.genericShowArgsNoArguments)({
        reflectSymbol: function () {
            return "UserDisabled";
        }
    })))))
};
var genericPromotionalItemTarget = {
    to: function (x) {
        if (x instanceof Data_Generic_Rep.Inl) {
            return TargetCart.value;
        };
        if (x instanceof Data_Generic_Rep.Inr) {
            return new TargetProductItems(x.value0);
        };
        throw new Error("Failed pattern match at Restaumatic.PromotionsEngine.Cart.PromotionalItem (line 36, column 1 - line 36, column 84): " + [ x.constructor.name ]);
    },
    from: function (x) {
        if (x instanceof TargetCart) {
            return new Data_Generic_Rep.Inl(Data_Generic_Rep.NoArguments.value);
        };
        if (x instanceof TargetProductItems) {
            return new Data_Generic_Rep.Inr(x.value0);
        };
        throw new Error("Failed pattern match at Restaumatic.PromotionsEngine.Cart.PromotionalItem (line 36, column 1 - line 36, column 84): " + [ x.constructor.name ]);
    }
};
var showPromotionalItemTarget = function (dictShow) {
    return {
        show: Data_Show_Generic.genericShow(genericPromotionalItemTarget)(Data_Show_Generic.genericShowSum(Data_Show_Generic.genericShowConstructor(Data_Show_Generic.genericShowArgsNoArguments)({
            reflectSymbol: function () {
                return "TargetCart";
            }
        }))(Data_Show_Generic.genericShowConstructor(Data_Show_Generic.genericShowArgsArgument(Data_Set.showSet(Restaumatic_PromotionsEngine_Cart_ProductItem.showProductItemKey(dictShow))))({
            reflectSymbol: function () {
                return "TargetProductItems";
            }
        })))
    };
};
var genericPromotionalItemSource = {
    to: function (x) {
        if (x instanceof Data_Generic_Rep.Inl) {
            return NoSource.value;
        };
        if (x instanceof Data_Generic_Rep.Inr) {
            return new SourceProductItems(x.value0);
        };
        throw new Error("Failed pattern match at Restaumatic.PromotionsEngine.Cart.PromotionalItem (line 48, column 1 - line 48, column 84): " + [ x.constructor.name ]);
    },
    from: function (x) {
        if (x instanceof NoSource) {
            return new Data_Generic_Rep.Inl(Data_Generic_Rep.NoArguments.value);
        };
        if (x instanceof SourceProductItems) {
            return new Data_Generic_Rep.Inr(x.value0);
        };
        throw new Error("Failed pattern match at Restaumatic.PromotionsEngine.Cart.PromotionalItem (line 48, column 1 - line 48, column 84): " + [ x.constructor.name ]);
    }
};
var showPromotionalItemSource = function (dictShow) {
    return {
        show: Data_Show_Generic.genericShow(genericPromotionalItemSource)(Data_Show_Generic.genericShowSum(Data_Show_Generic.genericShowConstructor(Data_Show_Generic.genericShowArgsNoArguments)({
            reflectSymbol: function () {
                return "NoSource";
            }
        }))(Data_Show_Generic.genericShowConstructor(Data_Show_Generic.genericShowArgsArgument(Data_Show.showArray(Restaumatic_PromotionsEngine_Cart_ProductItem.showProductItemKey(dictShow))))({
            reflectSymbol: function () {
                return "SourceProductItems";
            }
        })))
    };
};
var genericPromotionalItemAssignment = {
    to: function (x) {
        if (x instanceof Data_Generic_Rep.Inl) {
            return AssignmentToCart.value;
        };
        if (x instanceof Data_Generic_Rep.Inr && x.value0 instanceof Data_Generic_Rep.Inl) {
            return UnassignmentToCart.value;
        };
        if (x instanceof Data_Generic_Rep.Inr && (x.value0 instanceof Data_Generic_Rep.Inr && x.value0.value0 instanceof Data_Generic_Rep.Inl)) {
            return new AssignmentToProduct(x.value0.value0.value0);
        };
        if (x instanceof Data_Generic_Rep.Inr && (x.value0 instanceof Data_Generic_Rep.Inr && x.value0.value0 instanceof Data_Generic_Rep.Inr)) {
            return UnassignmentToProduct.value;
        };
        throw new Error("Failed pattern match at Restaumatic.PromotionsEngine.Cart.PromotionalItem (line 67, column 1 - line 67, column 92): " + [ x.constructor.name ]);
    },
    from: function (x) {
        if (x instanceof AssignmentToCart) {
            return new Data_Generic_Rep.Inl(Data_Generic_Rep.NoArguments.value);
        };
        if (x instanceof UnassignmentToCart) {
            return new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inl(Data_Generic_Rep.NoArguments.value));
        };
        if (x instanceof AssignmentToProduct) {
            return new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inl(x.value0)));
        };
        if (x instanceof UnassignmentToProduct) {
            return new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(Data_Generic_Rep.NoArguments.value)));
        };
        throw new Error("Failed pattern match at Restaumatic.PromotionsEngine.Cart.PromotionalItem (line 67, column 1 - line 67, column 92): " + [ x.constructor.name ]);
    }
};
var showPromotionalItemAssignment = function (dictShow) {
    return {
        show: Data_Show_Generic.genericShow(genericPromotionalItemAssignment)(Data_Show_Generic.genericShowSum(Data_Show_Generic.genericShowConstructor(Data_Show_Generic.genericShowArgsNoArguments)({
            reflectSymbol: function () {
                return "AssignmentToCart";
            }
        }))(Data_Show_Generic.genericShowSum(Data_Show_Generic.genericShowConstructor(Data_Show_Generic.genericShowArgsNoArguments)({
            reflectSymbol: function () {
                return "UnassignmentToCart";
            }
        }))(Data_Show_Generic.genericShowSum(Data_Show_Generic.genericShowConstructor(Data_Show_Generic.genericShowArgsArgument(Restaumatic_PromotionsEngine_Cart_ProductItem.showProductItemKey(dictShow)))({
            reflectSymbol: function () {
                return "AssignmentToProduct";
            }
        }))(Data_Show_Generic.genericShowConstructor(Data_Show_Generic.genericShowArgsNoArguments)({
            reflectSymbol: function () {
                return "UnassignmentToProduct";
            }
        })))))
    };
};
var showPromotionalItem = function (dictShow) {
    return {
        show: function (item) {
            var rawItem = Data_Newtype.unwrap()(item);
            return "PromotionalItem" + ("\x0a{ promotionalItemId: " + (Data_Show.show(Data_Show.showInt)(rawItem.promotionalItemId) + ("\x0a, promotion:         " + (Data_Show.show(Restaumatic_PromotionsEngine_Promotions_Promotion.showPromotion)(rawItem.promotion) + ("\x0a, target:            " + (Data_Show.show(showPromotionalItemTarget(dictShow))(rawItem.target) + ("\x0a, source:            " + (Data_Show.show(showPromotionalItemSource(dictShow))(rawItem.source) + ("\x0a, assignment:        " + (Data_Show.show(showPromotionalItemAssignment(dictShow))(rawItem.assignment) + ("\x0a, selection:         " + (Data_Show.show(showSelectionStatus)(rawItem.selection) + ("\x0a, input:             " + (Data_Show.show(Restaumatic_Promotions_Types_PromotionalItem.showPromotionalItemInput)(rawItem.input) + ("\x0a, value:             " + (Data_Show.show(Data_Maybe.showMaybe(Data_Money_Rounded.showMoney))(rawItem.value) + ("\x0a, active:            " + (Data_Show.show(Data_Show.showBoolean)(rawItem.active) + "\x0a}"))))))))))))))))));
        }
    };
};
var genericPromotionalItem = {
    to: function (x) {
        return x;
    },
    from: function (x) {
        return x;
    }
};
var functorPromotionalItemSource = {
    map: function (f) {
        return function (m) {
            if (m instanceof NoSource) {
                return NoSource.value;
            };
            if (m instanceof SourceProductItems) {
                return new SourceProductItems(Data_Functor.map(Data_Functor.functorArray)(Data_Functor.map(Restaumatic_PromotionsEngine_Cart_ProductItem.functorProductItemKey)(f))(m.value0));
            };
            throw new Error("Failed pattern match at Restaumatic.PromotionsEngine.Cart.PromotionalItem (line 47, column 1 - line 47, column 78): " + [ m.constructor.name ]);
        };
    }
};
var functorPromotionalItemAssignment = {
    map: function (f) {
        return function (m) {
            if (m instanceof AssignmentToCart) {
                return AssignmentToCart.value;
            };
            if (m instanceof UnassignmentToCart) {
                return UnassignmentToCart.value;
            };
            if (m instanceof AssignmentToProduct) {
                return new AssignmentToProduct(Data_Functor.map(Restaumatic_PromotionsEngine_Cart_ProductItem.functorProductItemKey)(f)(m.value0));
            };
            if (m instanceof UnassignmentToProduct) {
                return UnassignmentToProduct.value;
            };
            throw new Error("Failed pattern match at Restaumatic.PromotionsEngine.Cart.PromotionalItem (line 68, column 1 - line 68, column 86): " + [ m.constructor.name ]);
        };
    }
};
var forceSetAssignment = function (assignementStatus) {
    return function (promoItem) {
        return Data_Newtype.wrap()((function () {
            var v = Data_Newtype.unwrap()(promoItem);
            var $155 = {};
            for (var $156 in v) {
                if ({}.hasOwnProperty.call(v, $156)) {
                    $155[$156] = v[$156];
                };
            };
            $155.assignment = assignementStatus;
            return $155;
        })());
    };
};
var setAssignment = function (dictOrd) {
    return function (ass) {
        return function (promoItem) {
            var tgt = Restaumatic_PromotionsEngine_Promotions_Promotion.promotionTarget(promotion(promoItem));
            if (ass instanceof AssignmentToCart && Data_Eq.eq(Restaumatic_PromotionsEngine_Promotions_Types_Promotion.eqPromotionTarget)(tgt)(Restaumatic_PromotionsEngine_Promotions_Types_Promotion.CartTarget.value)) {
                return forceSetAssignment(ass)(promoItem);
            };
            if (ass instanceof UnassignmentToCart && Data_Eq.eq(Restaumatic_PromotionsEngine_Promotions_Types_Promotion.eqPromotionTarget)(tgt)(Restaumatic_PromotionsEngine_Promotions_Types_Promotion.CartTarget.value)) {
                return forceSetAssignment(ass)(promoItem);
            };
            if (ass instanceof AssignmentToProduct && (Data_Eq.eq(Restaumatic_PromotionsEngine_Promotions_Types_Promotion.eqPromotionTarget)(tgt)(Restaumatic_PromotionsEngine_Promotions_Types_Promotion.ProductTarget.value) && targetContains(dictOrd)(promoItem)(ass.value0))) {
                return forceSetAssignment(ass)(promoItem);
            };
            if (ass instanceof UnassignmentToProduct && Data_Eq.eq(Restaumatic_PromotionsEngine_Promotions_Types_Promotion.eqPromotionTarget)(tgt)(Restaumatic_PromotionsEngine_Promotions_Types_Promotion.ProductTarget.value)) {
                return forceSetAssignment(ass)(promoItem);
            };
            return promoItem;
        };
    };
};
var unassign = function (dictOrd) {
    return function (promoItem) {
        var v = Restaumatic_PromotionsEngine_Promotions_Promotion.promotionTarget(promotion(promoItem));
        if (v instanceof Restaumatic_PromotionsEngine_Promotions_Types_Promotion.CartTarget) {
            return setAssignment(dictOrd)(mkUnassignmentToCart)(promoItem);
        };
        if (v instanceof Restaumatic_PromotionsEngine_Promotions_Types_Promotion.ProductTarget) {
            return setAssignment(dictOrd)(mkUnassignmentToProduct)(promoItem);
        };
        throw new Error("Failed pattern match at Restaumatic.PromotionsEngine.Cart.PromotionalItem (line 349, column 3 - line 351, column 69): " + [ v.constructor.name ]);
    };
};
var excludeItemsFrom = function (subset) {
    return Data_Array.filter(function (item) {
        return Data_Foldable.notElem(Data_Foldable.foldableArray)(Data_Eq.eqInt)(promotionalItemId(item))(Data_Functor.map(Data_Functor.functorArray)(promotionalItemId)(subset));
    });
};
var eqSelectionStatus = {
    eq: /* #__PURE__ */ Data_Eq_Generic.genericEq(genericSelectionStatus)(/* #__PURE__ */ Data_Eq_Generic.genericEqSum(/* #__PURE__ */ Data_Eq_Generic.genericEqConstructor(Data_Eq_Generic.genericEqNoArguments))(/* #__PURE__ */ Data_Eq_Generic.genericEqSum(/* #__PURE__ */ Data_Eq_Generic.genericEqConstructor(Data_Eq_Generic.genericEqNoArguments))(/* #__PURE__ */ Data_Eq_Generic.genericEqSum(/* #__PURE__ */ Data_Eq_Generic.genericEqConstructor(/* #__PURE__ */ Data_Eq_Generic.genericEqArgument(Data_Eq.eqInt)))(/* #__PURE__ */ Data_Eq_Generic.genericEqConstructor(Data_Eq_Generic.genericEqNoArguments)))))
};
var eqPromotionalItemTarget = function (dictEq) {
    return {
        eq: Data_Eq_Generic.genericEq(genericPromotionalItemTarget)(Data_Eq_Generic.genericEqSum(Data_Eq_Generic.genericEqConstructor(Data_Eq_Generic.genericEqNoArguments))(Data_Eq_Generic.genericEqConstructor(Data_Eq_Generic.genericEqArgument(Data_Set.eqSet(Restaumatic_PromotionsEngine_Cart_ProductItem.eqProductItemKey(dictEq))))))
    };
};
var eqPromotionalItemSource = function (dictEq) {
    return {
        eq: Data_Eq_Generic.genericEq(genericPromotionalItemSource)(Data_Eq_Generic.genericEqSum(Data_Eq_Generic.genericEqConstructor(Data_Eq_Generic.genericEqNoArguments))(Data_Eq_Generic.genericEqConstructor(Data_Eq_Generic.genericEqArgument(Data_Eq.eqArray(Restaumatic_PromotionsEngine_Cart_ProductItem.eqProductItemKey(dictEq))))))
    };
};
var eqPromotionalItemAssignment = function (dictEq) {
    return {
        eq: Data_Eq_Generic.genericEq(genericPromotionalItemAssignment)(Data_Eq_Generic.genericEqSum(Data_Eq_Generic.genericEqConstructor(Data_Eq_Generic.genericEqNoArguments))(Data_Eq_Generic.genericEqSum(Data_Eq_Generic.genericEqConstructor(Data_Eq_Generic.genericEqNoArguments))(Data_Eq_Generic.genericEqSum(Data_Eq_Generic.genericEqConstructor(Data_Eq_Generic.genericEqArgument(Restaumatic_PromotionsEngine_Cart_ProductItem.eqProductItemKey(dictEq))))(Data_Eq_Generic.genericEqConstructor(Data_Eq_Generic.genericEqNoArguments)))))
    };
};
var eqPromotionalItem = function (dictEq) {
    return {
        eq: Data_Eq_Generic.genericEq(genericPromotionalItem)(Data_Eq_Generic.genericEqConstructor(Data_Eq_Generic.genericEqArgument(Data_Eq.eqRec()(Data_Eq.eqRowCons(Data_Eq.eqRowCons(Data_Eq.eqRowCons(Data_Eq.eqRowCons(Data_Eq.eqRowCons(Data_Eq.eqRowCons(Data_Eq.eqRowCons(Data_Eq.eqRowCons(Data_Eq.eqRowCons(Data_Eq.eqRowNil)()({
            reflectSymbol: function () {
                return "value";
            }
        })(Data_Maybe.eqMaybe(Data_Money_Rounded.eqMoney)))()({
            reflectSymbol: function () {
                return "target";
            }
        })(eqPromotionalItemTarget(dictEq)))()({
            reflectSymbol: function () {
                return "source";
            }
        })(eqPromotionalItemSource(dictEq)))()({
            reflectSymbol: function () {
                return "selection";
            }
        })(eqSelectionStatus))()({
            reflectSymbol: function () {
                return "promotionalItemId";
            }
        })(Data_Eq.eqInt))()({
            reflectSymbol: function () {
                return "promotion";
            }
        })(Restaumatic_PromotionsEngine_Promotions_Promotion.eqPromotion))()({
            reflectSymbol: function () {
                return "input";
            }
        })(Restaumatic_Promotions_Types_PromotionalItem.eqPromotionalItemInput))()({
            reflectSymbol: function () {
                return "assignment";
            }
        })(eqPromotionalItemAssignment(dictEq)))()({
            reflectSymbol: function () {
                return "active";
            }
        })(Data_Eq.eqBoolean)))))
    };
};
var ordPromotionalItem = function (dictEq) {
    return {
        compare: function (a) {
            return function (b) {
                return Data_Foldable.fold(Data_Foldable.foldableArray)(Data_Monoid.monoidOrdering)([ Data_Ord.compare(Restaumatic_PromotionsEngine_Promotions_Promotion.ordPromotion)(promotion(a))(promotion(b)), Data_Ord.compare(Data_Ord.ordInt)(promotionalItemId(a))(promotionalItemId(b)) ]);
            };
        },
        Eq0: function () {
            return eqPromotionalItem(dictEq);
        }
    };
};
var encodeSelectionStatus = {
    encode: /* #__PURE__ */ Foreign_Encoding.defaultEncode(genericSelectionStatus)(/* #__PURE__ */ Foreign_Generic_Class.genericEncodeSum(/* #__PURE__ */ Foreign_Generic_Class.genericEncodeConstructor({
        reflectSymbol: function () {
            return "AutoEnabled";
        }
    })(Foreign_Generic_Class.genericEncodeArgsNoArguments))(/* #__PURE__ */ Foreign_Generic_Class.genericEncodeSum(/* #__PURE__ */ Foreign_Generic_Class.genericEncodeConstructor({
        reflectSymbol: function () {
            return "AutoDisabled";
        }
    })(Foreign_Generic_Class.genericEncodeArgsNoArguments))(/* #__PURE__ */ Foreign_Generic_Class.genericEncodeSum(/* #__PURE__ */ Foreign_Generic_Class.genericEncodeConstructor({
        reflectSymbol: function () {
            return "UserEnabled";
        }
    })(/* #__PURE__ */ Foreign_Generic_Class.genericEncodeArgsArgument(/* #__PURE__ */ Foreign_Generic_Class.encodeWithOptionsOther(Foreign_Generic_Class.intEncode))))(/* #__PURE__ */ Foreign_Generic_Class.genericEncodeConstructor({
        reflectSymbol: function () {
            return "UserDisabled";
        }
    })(Foreign_Generic_Class.genericEncodeArgsNoArguments)))))
};
var encodePromotionalItemSource = function (dictEncode) {
    return {
        encode: Foreign_Encoding.defaultEncode(genericPromotionalItemSource)(Foreign_Generic_Class.genericEncodeSum(Foreign_Generic_Class.genericEncodeConstructor({
            reflectSymbol: function () {
                return "NoSource";
            }
        })(Foreign_Generic_Class.genericEncodeArgsNoArguments))(Foreign_Generic_Class.genericEncodeConstructor({
            reflectSymbol: function () {
                return "SourceProductItems";
            }
        })(Foreign_Generic_Class.genericEncodeArgsArgument(Foreign_Generic_Class.encodeWithOptionsOther(Foreign_Generic_Class.arrayEncode(dictEncode))))))
    };
};
var encodePromotionalItemAssignment = function (dictEncode) {
    return {
        encode: Foreign_Encoding.defaultEncode(genericPromotionalItemAssignment)(Foreign_Generic_Class.genericEncodeSum(Foreign_Generic_Class.genericEncodeConstructor({
            reflectSymbol: function () {
                return "AssignmentToCart";
            }
        })(Foreign_Generic_Class.genericEncodeArgsNoArguments))(Foreign_Generic_Class.genericEncodeSum(Foreign_Generic_Class.genericEncodeConstructor({
            reflectSymbol: function () {
                return "UnassignmentToCart";
            }
        })(Foreign_Generic_Class.genericEncodeArgsNoArguments))(Foreign_Generic_Class.genericEncodeSum(Foreign_Generic_Class.genericEncodeConstructor({
            reflectSymbol: function () {
                return "AssignmentToProduct";
            }
        })(Foreign_Generic_Class.genericEncodeArgsArgument(Foreign_Generic_Class.encodeWithOptionsOther(dictEncode))))(Foreign_Generic_Class.genericEncodeConstructor({
            reflectSymbol: function () {
                return "UnassignmentToProduct";
            }
        })(Foreign_Generic_Class.genericEncodeArgsNoArguments)))))
    };
};
var defaultInput = function (promo) {
    var v = Restaumatic_PromotionsEngine_Promotions_Promotion.promotionPrize(promo);
    if (v instanceof Restaumatic_PromotionsEngine_Promotions_Types_Promotion.Freeby) {
        var name = Restaumatic_PromotionsEngine_Promotions_Promotion.getFirstPromotionFreebyName(promo);
        return new Restaumatic_Promotions_Types_PromotionalItem.FreeProductInput({
            selection: Data_Maybe.fromMaybe("")(name)
        });
    };
    if (v instanceof Restaumatic_PromotionsEngine_Promotions_Types_Promotion.PercentageDiscount) {
        return Restaumatic_Promotions_Types_PromotionalItem.NoInput.value;
    };
    if (v instanceof Restaumatic_PromotionsEngine_Promotions_Types_Promotion.PriceDiscount) {
        return Restaumatic_Promotions_Types_PromotionalItem.NoInput.value;
    };
    if (v instanceof Restaumatic_PromotionsEngine_Promotions_Types_Promotion.CouponValue) {
        return Restaumatic_Promotions_Types_PromotionalItem.NoInput.value;
    };
    if (v instanceof Restaumatic_PromotionsEngine_Promotions_Types_Promotion.TextInformation) {
        return Restaumatic_Promotions_Types_PromotionalItem.NoInput.value;
    };
    throw new Error("Failed pattern match at Restaumatic.PromotionsEngine.Cart.PromotionalItem (line 357, column 3 - line 362, column 31): " + [ v.constructor.name ]);
};
var mkDefaultPromotionalItem = function (promoItemId) {
    return function (promo) {
        return function (assignmentMode) {
            var initialAssignment = (function () {
                var $165 = Data_Eq.eq(Restaumatic_PromotionsEngine_Cart_CartParams.eqAssignmentMode)(assignmentMode)(Restaumatic_PromotionsEngine_Cart_CartParams.AutoAssign.value);
                if ($165) {
                    return AutoDisabled.value;
                };
                return UserDisabled.value;
            })();
            return mkPromotionalItem(promoItemId)(promo)(initialAssignment)(defaultInput(promo))(Data_Maybe.Nothing.value)(mkDefaultAssignment(promo));
        };
    };
};
var decodeSelectionStatus = {
    decode: /* #__PURE__ */ Foreign_Encoding.defaultDecode(genericSelectionStatus)(/* #__PURE__ */ Foreign_Generic_Class.genericDecodeSum(/* #__PURE__ */ Foreign_Generic_Class.genericDecodeConstructor({
        reflectSymbol: function () {
            return "AutoEnabled";
        }
    })(Foreign_Generic_Class.genericDecodeArgsNoArguments)(Foreign_Generic_Class.genericCountArgsNoArguments))(/* #__PURE__ */ Foreign_Generic_Class.genericDecodeSum(/* #__PURE__ */ Foreign_Generic_Class.genericDecodeConstructor({
        reflectSymbol: function () {
            return "AutoDisabled";
        }
    })(Foreign_Generic_Class.genericDecodeArgsNoArguments)(Foreign_Generic_Class.genericCountArgsNoArguments))(/* #__PURE__ */ Foreign_Generic_Class.genericDecodeSum(/* #__PURE__ */ Foreign_Generic_Class.genericDecodeConstructor({
        reflectSymbol: function () {
            return "UserEnabled";
        }
    })(/* #__PURE__ */ Foreign_Generic_Class.genericDecodeArgsArgument(/* #__PURE__ */ Foreign_Generic_Class.decodeWithOptionsOther(Foreign_Generic_Class.intDecode)))(Foreign_Generic_Class.genericCountArgsArgument))(/* #__PURE__ */ Foreign_Generic_Class.genericDecodeConstructor({
        reflectSymbol: function () {
            return "UserDisabled";
        }
    })(Foreign_Generic_Class.genericDecodeArgsNoArguments)(Foreign_Generic_Class.genericCountArgsNoArguments)))))
};
var decodePromotionalItemSource = function (dictDecode) {
    return {
        decode: Foreign_Encoding.defaultDecode(genericPromotionalItemSource)(Foreign_Generic_Class.genericDecodeSum(Foreign_Generic_Class.genericDecodeConstructor({
            reflectSymbol: function () {
                return "NoSource";
            }
        })(Foreign_Generic_Class.genericDecodeArgsNoArguments)(Foreign_Generic_Class.genericCountArgsNoArguments))(Foreign_Generic_Class.genericDecodeConstructor({
            reflectSymbol: function () {
                return "SourceProductItems";
            }
        })(Foreign_Generic_Class.genericDecodeArgsArgument(Foreign_Generic_Class.decodeWithOptionsOther(Foreign_Generic_Class.arrayDecode(dictDecode))))(Foreign_Generic_Class.genericCountArgsArgument)))
    };
};
var decodePromotionalItemAssignment = function (dictDecode) {
    return {
        decode: Foreign_Encoding.defaultDecode(genericPromotionalItemAssignment)(Foreign_Generic_Class.genericDecodeSum(Foreign_Generic_Class.genericDecodeConstructor({
            reflectSymbol: function () {
                return "AssignmentToCart";
            }
        })(Foreign_Generic_Class.genericDecodeArgsNoArguments)(Foreign_Generic_Class.genericCountArgsNoArguments))(Foreign_Generic_Class.genericDecodeSum(Foreign_Generic_Class.genericDecodeConstructor({
            reflectSymbol: function () {
                return "UnassignmentToCart";
            }
        })(Foreign_Generic_Class.genericDecodeArgsNoArguments)(Foreign_Generic_Class.genericCountArgsNoArguments))(Foreign_Generic_Class.genericDecodeSum(Foreign_Generic_Class.genericDecodeConstructor({
            reflectSymbol: function () {
                return "AssignmentToProduct";
            }
        })(Foreign_Generic_Class.genericDecodeArgsArgument(Foreign_Generic_Class.decodeWithOptionsOther(dictDecode)))(Foreign_Generic_Class.genericCountArgsArgument))(Foreign_Generic_Class.genericDecodeConstructor({
            reflectSymbol: function () {
                return "UnassignmentToProduct";
            }
        })(Foreign_Generic_Class.genericDecodeArgsNoArguments)(Foreign_Generic_Class.genericCountArgsNoArguments)))))
    };
};
var combineableClique = function (promotionalItems) {
    var promotionsClique = Restaumatic_PromotionsEngine_Promotions_Promotion.combineableClique(Data_Functor.map(Data_Functor.functorArray)(promotion)(promotionalItems));
    return Data_Array.filter(function (item) {
        return Data_Foldable.elem(Data_Foldable.foldableArray)(Restaumatic_PromotionsEngine_Promotions_Promotion.eqPromotion)(promotion(item))(promotionsClique);
    })(promotionalItems);
};
var changeInput = function (dictEq) {
    return function (promotionalItem) {
        return function (newInput) {
            if (newInput instanceof Restaumatic_Promotions_Types_PromotionalItem.FreeProductInput) {
                return selectFreeby(newInput.value0.selection)(promotionalItem);
            };
            if (newInput instanceof Restaumatic_Promotions_Types_PromotionalItem.NoInput) {
                return setNoInput(promotionalItem);
            };
            throw new Error("Failed pattern match at Restaumatic.PromotionsEngine.Cart.PromotionalItem (line 377, column 3 - line 379, column 42): " + [ newInput.constructor.name ]);
        };
    };
};
var canCombineWithAllOthers = function (promotionalItem) {
    return function (promotionalItems) {
        return Restaumatic_PromotionsEngine_Promotions_Promotion.canCombineWithAllOthers(promotion(promotionalItem))(Data_Functor.map(Data_Functor.functorArray)(promotion)(promotionalItems));
    };
};
var canCombineWithAll = function (promotionalItem) {
    return function (promotionalItems) {
        return Restaumatic_PromotionsEngine_Promotions_Promotion.canCombineWithAll(promotion(promotionalItem))(Data_Functor.map(Data_Functor.functorArray)(promotion)(promotionalItems));
    };
};
var partitionCombineable = function (promotionalItems) {
    var v = Restaumatic_PromotionsEngine_Common.partitionTuple(isEnabled)(promotionalItems);
    var v1 = Restaumatic_PromotionsEngine_Common.partitionTuple(function (v2) {
        return canCombineWithAll(v2)(v.value0);
    })(v.value1);
    return new Data_Tuple.Tuple(Data_Semigroup.append(Data_Semigroup.semigroupArray)(v.value0)(v1.value0), v1.value1);
};
var canCombineWith = function (otherPromotionalItem) {
    return function (promotionalItem) {
        return Restaumatic_PromotionsEngine_Promotions_Promotion.canCombineWith(promotion(otherPromotionalItem))(promotion(promotionalItem));
    };
};
var assignmentProductItemKey = function (assign) {
    if (assign instanceof AssignmentToProduct) {
        return new Data_Maybe.Just(assign.value0);
    };
    return Data_Maybe.Nothing.value;
};
var assignment = /* #__PURE__ */ (function () {
    var $216 = Data_Newtype.unwrap();
    return function ($217) {
        return (function (v) {
            return v.assignment;
        })($216($217));
    };
})();
var resetPromotionalItem = function (dictOrd) {
    return function (item) {
        var disabledItem = (function () {
            var $177 = isTouchedByUser(item);
            if ($177) {
                return setSelection(UserDisabled.value)(item);
            };
            return setSelection(AutoDisabled.value)(item);
        })();
        var unassignedDisabledItem = (function () {
            var v = assignment(disabledItem);
            if (v instanceof AssignmentToCart) {
                return setAssignment(dictOrd)(UnassignmentToCart.value)(disabledItem);
            };
            if (v instanceof AssignmentToProduct) {
                return setAssignment(dictOrd)(UnassignmentToProduct.value)(disabledItem);
            };
            return disabledItem;
        })();
        return unassignedDisabledItem;
    };
};
var resetPromotionalItems = function (dictOrd) {
    return Data_Functor.map(Data_Functor.functorArray)(resetPromotionalItem(dictOrd));
};
var assignedProductItemKey = function ($218) {
    return assignmentProductItemKey(assignment($218));
};
var allocatedProductItemKeys = function (item) {
    var v = assignmentProductItemKey(assignment(item));
    if (v instanceof Data_Maybe.Just) {
        return Data_Array.cons(v.value0)(sourceProductItems(item));
    };
    if (v instanceof Data_Maybe.Nothing) {
        return [  ];
    };
    throw new Error("Failed pattern match at Restaumatic.PromotionsEngine.Cart.PromotionalItem (line 397, column 3 - line 399, column 18): " + [ v.constructor.name ]);
};
var allCombineable = function (promotionalItem) {
    return Data_Array.filter(canCombineWith(promotionalItem));
};
export {
    PromotionalItem,
    AssignmentToCart,
    UnassignmentToCart,
    AssignmentToProduct,
    UnassignmentToProduct,
    NoSource,
    SourceProductItems,
    TargetCart,
    TargetProductItems,
    AutoEnabled,
    AutoDisabled,
    UserEnabled,
    UserDisabled,
    allCombineable,
    allocatedProductItemKeys,
    assignedProductItemKey,
    assignment,
    assignmentProductItemKey,
    canCombineWith,
    canCombineWithAll,
    canCombineWithAllOthers,
    changeInput,
    combineableClique,
    defaultInput,
    excludeItemsFrom,
    forceSetAssignment,
    hasRequiredInput,
    input,
    isActive,
    isAutoAssignablePromotionalItem,
    isCartPromotionalItem,
    isEnabled,
    isEnabledByUser,
    isEnabledSelection,
    isItemAutoAssigneable,
    isProductPromotionalItem,
    isTouchedByUser,
    isUserDisabledSelection,
    isUserEnabledSelection,
    isUserSelection,
    mkAssignmentToCart,
    mkAssignmentToProduct,
    mkAutoDisabled,
    mkAutoEnabled,
    mkDefaultAssignment,
    mkDefaultPromotionalItem,
    mkFreeProductInput,
    mkNoInput,
    mkNoSource,
    mkPromotionalItem,
    mkSourceItems,
    mkTargetCart,
    mkTargetItems,
    mkUnassignmentToCart,
    mkUnassignmentToProduct,
    mkUserDisabled,
    mkUserEnabled,
    mkUserEnabledDefault,
    oldenUserEnabledSelectionStatus,
    oldenUserSelection,
    partitionCombineable,
    productItemKeysInTarget,
    promotion,
    promotionId,
    promotionalItemId,
    promotionalItemInput,
    promotionalItemValue,
    promotions,
    resetPromotionalItem,
    resetPromotionalItems,
    selectFreeby,
    selectedFreeby,
    selection,
    selectionAge,
    selectionStatusAge,
    setActive,
    setAssignment,
    setInputFreeby,
    setNoInput,
    setSelection,
    setValue,
    source,
    sourceProductItems,
    target,
    targetContains,
    targetProductItemKeys,
    unassign,
    value,
    genericPromotionalItemTarget,
    showPromotionalItemTarget,
    eqPromotionalItemTarget,
    functorPromotionalItemSource,
    genericPromotionalItemSource,
    showPromotionalItemSource,
    eqPromotionalItemSource,
    encodePromotionalItemSource,
    decodePromotionalItemSource,
    genericPromotionalItemAssignment,
    functorPromotionalItemAssignment,
    showPromotionalItemAssignment,
    eqPromotionalItemAssignment,
    encodePromotionalItemAssignment,
    decodePromotionalItemAssignment,
    genericSelectionStatus,
    showSelectionStatus,
    eqSelectionStatus,
    encodeSelectionStatus,
    decodeSelectionStatus,
    newtypePromotionalItem,
    genericPromotionalItem,
    eqPromotionalItem,
    ordPromotionalItem,
    showPromotionalItem
};
export {
    FreeProductInput,
    NoInput
} from "../Restaumatic.Promotions.Types.PromotionalItem/index.js";
//# sourceMappingURL=index.js.map
